export default "__VITE_ASSET__yUnkyike__"